import { render, staticRenderFns } from "./VaultLockMonthDetail.vue?vue&type=template&id=aa3ec7c0&"
import script from "./VaultLockMonthDetail.vue?vue&type=script&lang=js&"
export * from "./VaultLockMonthDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports